import { render, staticRenderFns } from "./InvitationHistory.vue?vue&type=template&id=fb3e6422&scoped=true&"
import script from "./InvitationHistory.vue?vue&type=script&lang=js&"
export * from "./InvitationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3e6422",
  null
  
)

export default component.exports